import { Component, h } from 'preact';
import { PaginationDots } from '../../common/pagination-dots.component';

interface VlPropertySelectionHeaderProps {
  groupName: string;
  numGroups: number;
  currentPage: number;

  onPageSelect: (page: number) => void;
  onViewFtf?: () => void;
}

export class VlPropertySelectionHeader extends Component<VlPropertySelectionHeaderProps> {
  render() {
    const props = this.props;

    return (
      <div className="hi-vlmheader">
        {/* View FTF | Filter */}
        <ul className="hi-vlmheader__links-row">
          {/* 
            The blocky rectangular clipboard icon appears visually wider than
            the tapered funnel filter icon. Without an additional margin, it
            visually looks like the clipboard icon is closer to "View FTF" than
            the filter is to the "Filter" text, despite being equally spaced.

            The mockup takes this visual quirk into account. Here, we do the
            same by adding an mr-1.
          */}
          <li>
            <button className="btn btn-link" onClick={ props.onViewFtf }>
              <i className="fas fa-clipboard-list mr-1" /> View FTF
            </button>
          </li>
          {/* <li>
            <button className="btn btn-link">
              <i className="fas fa-filter" /> Filter
            </button>
          </li> */}
        </ul>

        <div className="hi-vlmheader__pager-row">
          <button className="hi-vlmheader__chevron-left"
            disabled={ props.currentPage === 1}
            onClick={ () => props.onPageSelect(props.currentPage - 1) }>
          </button>
          <div className="hi-vlmheader__group-name-container">
            <label className="hi-vlmheader__group-name">
              { props.groupName }
            </label>
            <PaginationDots 
              pageCount={ props.numGroups }
              currentPage={ props.currentPage }
              onPageSelect={ page => props.onPageSelect(page) } />
          </div>
          <button className="hi-vlmheader__chevron-right"
            disabled={ props.currentPage >= props.numGroups }
            onClick={ () => props.onPageSelect(props.currentPage + 1) }>
          </button>
        </div>

        {/* Left/right chevrons + group name heading + dots */}
      </div>
    )
  }
}
